import { logWrapper } from '../../utils';

export default {
  crudGroupController: [
    'runtimeConstant',
    '$scope',
    '$controller',
    'service',
    '$uibModal',
    function (runtimeConstant, $scope, $controller, service, Modal) {
      'use strict';

      function setValue(folders, value, role, i) {
        if (value) {
          if (!Array.isArray(folders[i].permissions)) {
            folders[i].permissions = [];
          }

          if (folders[i].permissions.indexOf(role) === -1) {
            folders[i].permissions.push(role);
          }
        } else {
          if (!Array.isArray(folders[i].permissions)) {
            return true;
          }

          var index = folders[i].permissions.indexOf(role);

          if (index > -1) {
            folders[i].permissions.splice(index, 1);
          }
        }

        return false;
      }

      function showFeatures(role) {
        Modal.open({
          animation: true,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: '/views/modules/security/groups/featuresModal.html',
          controller: [
            '$scope',
            'role',
            function ($scope, role) {
              $scope.role = role;
            },
          ],
          size: 'sm',
          resolve: {
            role: function () {
              return role;
            },
          },
        });
      }

      function roleSelected(value) {
        var role = this.r.id;

        if (arguments.length > 0) {
          var folders = this.currentItem.selectedFolders;

          for (var i = 0, len = folders.length; i < len; i++) {
            $scope.setValue(folders, value, role, i);
          }
        } else {
          if (
            !Array.isArray(this.currentItem.selectedFolders) ||
            this.currentItem.selectedFolders.length === 0
          ) {
            return false;
          }

          var anySelected = this.currentItem.selectedFolders.some(function (f) {
            return Array.isArray(f.permissions)
              ? f.permissions.indexOf(role) !== -1
              : false;
          });
          var isSelected = anySelected
            ? this.currentItem.selectedFolders.every(function (f) {
                return Array.isArray(f.permissions)
                  ? f.permissions.indexOf(role) !== -1
                  : false;
              })
              ? true
              : null
            : false;

          return isSelected;
        }
      }

      function run() {
        try {
          $controller('crudController', { $scope: $scope, service: service });

          $scope.setValue = logWrapper(
            setValue,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showFeatures = logWrapper(
            showFeatures,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.roleSelected = logWrapper(
            roleSelected,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
